export enum ConversationSidePanelTab {
  customer = "customer",
  tickets = "tickets",
  tasks = "tasks",
  history = "history",
}
